import React, { useEffect, useRef, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from '../../store/actions/todoActions';

import { useDispatch, useSelector } from "react-redux";
import ArticleTrendSlider from "./ArticleTrendSlider";
import ConditionalRender from "../../components/Common/ConditionalRender";
import Button from "../../components/Common/Button";
import ListBlog from "./ListBlog";
import ArticlePopular from "./ArticlePopular";
import { useHandleClickLoading } from "../../components/Common/utils";
import { useLocation } from "react-router";

function SearchBlog() {
  const isIdTarget = useSelector(state => state.todoReducer.isIdTarget);
  const [trendBlogData, setTrendBlog] = useState([]);
  const [jenisBlogTerbaru, setJenisBlogTerbaru] = useState([]);
  const [jenisArtikeldata, setJenisArtikelData] = useState([]);

  const [trendBlogLoading, settrendBlogLoading] = useState(true);
  const [blogTerbaruLoading, setBlogTerbaruLoading] = useState(true);

  const [limit, setLimit] = useState(5);
  const dispatch = useDispatch();
  const location = useLocation();
  const handleClickLoading = useHandleClickLoading();

  useEffect(() => {
    fetchDataArticle();
    fetchJenisArticle()
  }, [location]);
  useEffect(() => {
    fetchJenisBlog()
  }, [location,limit]);



  const fetchDataArticle = async () => {
    settrendBlogLoading(true);
    try {
      const response = await ApiService({
        baseurl: "user/jenisBlog?trending",
        method: "GET",
        XGORDON: "JENISBLOG"
      });
      settrendBlogLoading(false);
      if (response?.statusCode === 200) {
        setTrendBlog(response.result.data);
      } else {
        setTrendBlog([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchJenisArticle = async () => {
    try {
      const response = await ApiService({
        baseurl: "user/jenisArtikel",
        method: "GET",
        XGORDON: "JENISARTIKEL"
      });
      if (response?.statusCode === 200) {
        setJenisArtikelData(response.result.data);
      } else {
        setJenisArtikelData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchJenisBlog = async () => {
    setBlogTerbaruLoading(true);
    const params = new URLSearchParams();
    params.append("idJenis", isIdTarget);
    params.append("page", "0");
    params.append("limit", limit);

    try {
      const response = await ApiService({
        baseurl: "user/jenisBlog?jenis",
        method: "POST",
        XGORDON: "JENISBLOG",
        body: params,
      });
      setBlogTerbaruLoading(false);
      if (response?.statusCode === 200) {
        setJenisBlogTerbaru(response.result.data);
      } else {
        setJenisBlogTerbaru([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="flex flex-col gap-3 flex-1">
      <ListBlog data={jenisArtikeldata} />
      <div className="flex flex-row gap-2 px-2">
        <div className="w-[1px] h-6 bg-[#ED610A]" />
        <span className="text-base font-semibold">
          BROWSING :{" "}
          <span className="text-[#ED610A]">
            {location?.pathname.replace('/search-blog/', '').replace('%20', ' ')}
          </span>
        </span>
      </div>
      <div className="flex sm:flex-row flex-col gap-3 px-2 ">
        <div className="flex flex-col gap-2 flex-1 ">
          <span className="font-semibold">Artikel Terbaru</span>
          <div className="flex w-full h-[1px] bg-[#f3f3f3]" />
          <ConditionalRender
            productsData={jenisBlogTerbaru}
            isLoading={blogTerbaruLoading}
            model={"emptyData"}
          >
            {jenisBlogTerbaru.map((item, index) => (
              <button
                onClick={() => { handleClickLoading('/news/' + item.slug) }}
                key={index}
                className="flex flex-row gap-2 border-b py-2"
              >
                <div className="sm:h-40 h-20 aspect-[3/2]">
                  <img
                    src={item.gambar}
                    alt={item.judul}
                    className="w-full h-full object-cover rounded-md pointer-events-none"
                  />
                </div>
                <div className="flex w-full flex-col gap-2">
                  <div className="flex flex-row w-full">
                    <div className="bg-[#22BDE2] p-1 rounded-tr-lg rounded-bl-lg px-3">
                      <span className="text-[#ffffff] text-left text-sm font-light line-clamp-1">
                        {item.jenis}
                      </span>
                    </div>
                  </div>

                  <span className="text-sm text-left font-bold line-clamp-3">
                    {item.judul}
                  </span>
                  <span className="text-xs text-left"><b className="text-[#22BDE2]">Writer</b> - {item.tanggal}</span>
                  <span className="text-xs text-left line-clamp-2">{item.sub_konten}</span>
                </div>
              </button>
            ))}
          </ConditionalRender>

          <div className="flex flex-row justify-center">
            <div>
              <Button
                initialValue="Tampilkan Semua"
                type="fill"
                className="border-[#22BDE2] border-2 text-[#22BDE2] dark:border-[#ffffff] h-[40px] dark:text-darkColor inline-flex rounded-md"
                onClick={() => { setLimit(limit+5)}}
              />
            </div>
          </div>
          {jenisBlogTerbaru.length !== 0 &&
            <div className="flex flex-row justify-center pt-2">
              <div>
                <Button
                  className={``}
                  initialValue="Tampilkan Semua"
                  type="outline"
                  color="text-[#01016F]"
                />
              </div>
            </div>}
        </div>
        <ArticlePopular data={trendBlogData} loading={trendBlogLoading} />
      </div>
    </div>
  );
}

export default SearchBlog;
